import { useRouter as nextRouter } from "next/router";

export default function useRouter()
{
    const router = nextRouter();

    return {
        ...router,
    };
}